module.exports = __webpack_public_path__ + "static/media/institute-14-min.f22e316f.webp";